import { IGetRegionResponseSchema } from '../../../../repositories/monolith-python/entities/schemas/GetRegionResponseSchema';
import { IRegion } from '../../../../types/geoSwitcher';

export function prepareSuggestions(regions?: IGetRegionResponseSchema[] | null): IRegion[] {
  if (!regions) {
    return [];
  }

  return regions.map(region => ({
    id: region.id,
    displayName: region.displayName,
    mainTownId: region.mainTownId || null,
    baseHost: null,
  }));
}
